module.exports = "/images/copy.svg?62ae6096ba0f8b5fda2e6f795c4ae62e";